import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import { AppMainService } from "src/app/app-main.service";
import { AppMainComponent } from "src/app/app.main.component";
import { RobotoFont } from "src/app/inventory/sales-order/utils/vfs";
import { jsPDF } from "jspdf";
import { Observable } from "rxjs";
@Component({
    selector: "app-finance-print-utility",
    templateUrl: "./finance-print-utility.component.html",
})
export class FinancePrintUtilityComponent implements OnChanges {
    @Input({ required: true }) selectedWindow;
    @Input({ required: true }) profitReport;
    @Input({ required: true }) selectedDateFilter;
    @Input({ required: true }) cols;
    @Input({ required: true }) dateTo;
    @Input({ required: true }) dateFrom;
    columnChunks: any[][] = [];
    chunkSize: number = 4;
    constructor(
        public app: AppMainComponent,
        private appMainService: AppMainService,
    ) {}
    ngOnChanges(changes: SimpleChanges): void {
        if (changes?.cols?.currentValue) {
            this.generateColumnPages();
        }
    }

    generateColumnPages() {
        this.appMainService.isShowSpinner("generateColumnPages");
        this.columnChunks = [];
        for (let i = 1; i < this.cols.length; i += this.chunkSize) {
            this.columnChunks.push([this.cols[0], ...this.cols.slice(i, i + this.chunkSize)]);
        }
        this.appMainService.isHideSpinner("generateColumnPages");
    }

    printSummary() {
        let pdf = new jsPDF("p", "pt", "a4", true);
        pdf.addFileToVFS("Roboto-Regular.ttf", RobotoFont);
        pdf.addFont("Roboto-Regular.ttf", "Roboto-Regular", "normal");
        pdf.setFont("Roboto-Regular");
        let html = document?.getElementById("summaryPreview").innerHTML;
        html = html.replace(/width="100%"/, 'width="555"');
        let pdfFileName = "Summary_Report";
        pdf.setProperties({ title: pdfFileName + ".pdf" });
        pdf.html(html, {
            margin: [30, 20],
            autoPaging: 'text',
            callback: (generatedPdf) => {
                const dataUri = generatedPdf.output("datauristring");
                const newTab = window.open();
                newTab?.document?.write('<iframe width="100%" height="100%" src="' + dataUri + '" type="application/pdf"></iframe>');
                if (newTab && newTab.document) {
                    newTab.document.title = pdfFileName + ".pdf";
                }
            },
        });
    }

    printDetails() {
        this.appMainService.isShowSpinner("printDetails");
        let pdf = new jsPDF("p", "pt", "a4", true);
        pdf.addFileToVFS("Roboto-Regular.ttf", RobotoFont);
        pdf.addFont("Roboto-Regular.ttf", "Roboto-Regular", "normal");
        pdf.setFont("Roboto-Regular");
        let html = document?.getElementById("detailsPreviewPrint").innerHTML;
        html = html.replace(/width="100%"/, 'width="555"');
        let pdfFileName = "Details_Report";
        pdf.setProperties({ title: pdfFileName + ".pdf" });
        pdf.html(html, {
            margin: [30, 20],
            autoPaging: 'text', 
            callback: (generatedPdf) => {
                const dataUri = generatedPdf.output("datauristring");
                this.appMainService.isHideSpinner("printDetails");
                const newTab = window.open();
                newTab?.document?.write('<iframe width="100%" height="100%" src="' + dataUri + '" type="application/pdf"></iframe>');
                if (newTab && newTab.document) {
                    newTab.document.title = pdfFileName + ".pdf";
                }
            },
        });
    }

    saveSummary() {
        this.appMainService.isShowSpinner("saveSummary");
        let pdf = new jsPDF("p", "pt", "a4", true);
        pdf.addFileToVFS("Roboto-Regular.ttf", RobotoFont);
        pdf.addFont("Roboto-Regular.ttf", "Roboto-Regular", "normal");
        pdf.setFont("Roboto-Regular");
        const summaryElement = document.getElementById("summaryPreview");
        let html = summaryElement.innerHTML;
        html = html.replace(/width="100%"/, 'width="555"');
        let pdfFileName = "Summary_Report.pdf";
        pdf.setProperties({ title: pdfFileName });
        pdf.html(html, {
            margin: [30, 20],
            autoPaging: 'text',
            callback: (generatedPdf) => {
                generatedPdf.save(pdfFileName);
                summaryElement.style.display = "none";
                this.appMainService.isHideSpinner("saveSummary");
            },
        });
    }

    saveDetails() {
        this.appMainService.isShowSpinner("saveDetails");
        let pdf = new jsPDF("p", "pt", "a4", true);
        pdf.addFileToVFS("Roboto-Regular.ttf", RobotoFont);
        pdf.addFont("Roboto-Regular.ttf", "Roboto-Regular", "normal");
        pdf.setFont("Roboto-Regular");

        const detailsElement = document.getElementById("detailsPreviewPrint");
        let html = detailsElement.innerHTML;
        html = html.replace(/width="100%"/, 'width="555"');
        let pdfFileName = "Details_Report.pdf";
        pdf.setProperties({ title: pdfFileName });
        pdf.html(html, {
            margin: [30, 20],
            autoPaging: 'text',
            callback: (generatedPdf) => {
                generatedPdf.save(pdfFileName);
                detailsElement.style.display = "none";
                this.appMainService.isHideSpinner("saveDetails");
            },
        });
    }

    getPdfReport(type: "details" | "summary"): Observable<any> {
        return new Observable((observer) => {
            this.appMainService.isShowSpinner("printpdf");
            setTimeout(() => {
                try {
                    let pdf = new jsPDF("p", "pt", "a4", true);
                    pdf.addFileToVFS("Roboto-Regular.ttf", RobotoFont);
                    pdf.addFont("Roboto-Regular.ttf", "Roboto-Regular", "normal");
                    pdf.setFont("Roboto-Regular");
                    let html = type == "details" ? document?.getElementById("detailsPreviewPrint")?.innerHTML : document?.getElementById("summaryPreview")?.innerHTML;
                    if (!html) {
                        throw new Error("HTML content not found for PDF generation.");
                    }
                    html = html.replace(/width="100%"/, 'width="555"');
                    pdf.html(html, {
                        margin: [30, 20],
                        autoPaging: 'text',
                        callback: (pdfOutput) => {
                            this.appMainService.isHideSpinner("printpdf");
                            observer.next(pdfOutput);
                            observer.complete();
                        },
                    });
                } catch (error) {
                    this.appMainService.isHideSpinner("printpdf");
                    observer.error(error);
                }
            }, 2000);
        });
    }
}
